<template>
  <div>

    <!-- <v-toolbar class="teal lighten-2 white--text"> -->
    <v-app-bar
      app
      height="60"
      :class="`header-partner-style ${PARTNER_CONFIG.theme_partner.header}`"
    >
      <!-- class="teal lighten-2 white--text" -->
      <span>{{login}}</span>
      <v-app-bar-nav-icon
        @click.stop="drawer=!drawer"
        class="hidden-md-and-up"
      >
      </v-app-bar-nav-icon>
      <v-img
        class="logo-partner"
        height="50"
        max-width="70"
        src='/../config/logo2.png'
      ></v-img>
      <router-link
        to='/'
        tag="span"
        style="cursor:pointer"
      >
        <v-toolbar-title :class="`text-wrap text-center  ${PARTNER_CONFIG.theme_partner.headerName}` ">
          {{PARTNER_CONFIG.partner_name}}
        </v-toolbar-title>
      </router-link>

      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-md-and-down ">
      </v-toolbar-items>
      <v-btn
        large
        :class=" ` hidden-sm-and-down ma-2 header-button-partner-style ${PARTNER_CONFIG.theme_partner.headerBtn}`"
        v-for="(item,i) in menuItems"
        :key="`menuItem${i}`"
        :to="item.route"
      >

        <v-icon>{{item.icon}}</v-icon>
        {{item.title}}

      </v-btn>

      <v-btn
        icon
        to="/"
        :class="`header-button-partner-style ${PARTNER_CONFIG.theme_partner.headerBtn}`"
      >
        <v-icon>mdi-home</v-icon>
      </v-btn>

    </v-app-bar>

    <v-navigation-drawer
      fixed
      dark
      id="nav-drawer"
      v-model="drawer"
    >
      <v-list>
        <v-list-item
          v-for="(item,i) in menuItems"
          :key="`drawer${i}`"
          :to="item.route"
        >
          <v-icon>{{ item.icon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-navigation-drawer>
  </div>

</template>

<script>
import { mapActions, mapGetters } from "vuex";
//import image from "./../config/logo.png";
export default {
  data() {
    return {
      drawer: false
    };
  },

  computed: {
    ...mapGetters(["PARTNER_CONFIG"]),
    isAuth() {
      return this.$store.getters.getAuth;
    },
    menuItems() {
      return [
        {
          title: "Вакансии",
          route: "/",
          icon: "mdi-alert-decagram-outline"
        },
        {
          title: "Контакты",
          route: "#kontakty",
          icon: "mdi-application-import"
        }
        // {
        //   title: "Vakansija",
        //   route: "/Vakansija",
        //   icon: "mdi-arm-flex-outline"
        // }
      ];
    },
    login() {
      return this.$store.getters.getLogin;
    }
  },
  methods: {
    ...mapActions(["GET_PARTNER_CONFIG_FROM_API"])
  },
  created() {
    this.GET_PARTNER_CONFIG_FROM_API();
  }
};
</script>

<style lang="scss" scoped>
#nav-drawer {
  margin-top: 55px;
}

.logo-partner {
  margin-right: 15px;
}
</style>
